import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "draivn-help-center-demo-form row drv-my-4" }
const _hoisted_2 = { class: "row gap col-12" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "row gap col-12" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "drv-text-body-md drv-mb-2" }

import { EMessagesKeys, type IDemoRequest } from "../../types";
import {
  emailValidator,
  maxLengthValidator,
  minLengthValidator,
  requiredValidator,
} from "draivn-ui-domain";
import { computed, ref } from "vue";
import type { Input } from "draivn-ui-kit";
import { I18N_SERVICE_INJECTION_KEY } from "@/constants";
import { injector } from "@/services";


export default /*@__PURE__*/_defineComponent({
  __name: 'DemoForm',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const i18n = injector.injectFromRoot(I18N_SERVICE_INJECTION_KEY);
const { t } = i18n.global;

const props = __props;

// eslint-disable-next-line func-call-spacing
const emit = __emit;

const EMPTY_MODEL: Required<IDemoRequest> = {
  email: "",
  phone: "",
  first_name: "",
  last_name: "",
  company: "",
  industry: "",
};

const model = computed<IDemoRequest>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: IDemoRequest) {
    emit("update:modelValue", value);
  },
});

const firstnameModel = computed<string>({
  get() {
    return props.modelValue?.first_name ?? EMPTY_MODEL.first_name;
  },
  set(value: string) {
    model.value = {
      ...model.value,
      first_name: value,
    };
  },
});

const lastnameModel = computed<string>({
  get() {
    return props.modelValue?.last_name ?? EMPTY_MODEL.last_name;
  },
  set(value: string) {
    model.value = {
      ...model.value,
      last_name: value,
    };
  },
});

const companyModel = computed<string>({
  get() {
    return props.modelValue?.company ?? EMPTY_MODEL.company;
  },
  set(value: string) {
    model.value = {
      ...model.value,
      company: value,
    };
  },
});

const phoneModel = computed<string>({
  get() {
    return props.modelValue?.phone ?? EMPTY_MODEL.phone;
  },
  set(value: string) {
    model.value = {
      ...model.value,
      phone: value,
    };
  },
});

const industryModel = computed<string>({
  get() {
    return props.modelValue?.industry ?? EMPTY_MODEL.industry;
  },
  set(value: string) {
    model.value = {
      ...model.value,
      industry: value,
    };
  },
});

const industryOptions = [
  { value: 1, label: "IT" },
  { value: 2, label: "Not IT" },
];

const emailModel = computed<string>({
  get() {
    return props.modelValue?.email ?? EMPTY_MODEL.email;
  },
  set(value: string) {
    model.value = {
      ...model.value,
      email: value,
    };
  },
});

const firstnameControl = ref<typeof Input | null>(null);
const lastnameControl = ref<typeof Input | null>(null);
const companyControl = ref<typeof Input | null>(null);
const phoneControl = ref<typeof Input | null>(null);
const emailControl = ref<typeof Input | null>(null);

const hasFormError = computed<boolean>(() => {
  return (
    !firstnameModel.value ||
    firstnameControl.value?.hasError ||
    !lastnameModel.value ||
    lastnameControl.value?.hasError ||
    !companyModel.value ||
    companyControl.value?.hasError ||
    !emailModel.value ||
    emailControl.value?.hasError ||
    !phoneModel.value ||
    phoneControl.value?.hasError ||
    !industryModel.value
  );
});
const hasError = computed<boolean>(() => {
  return hasFormError.value;
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_input = _resolveComponent("d-input")!
  const _component_d_select = _resolveComponent("d-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_d_input, {
          ref_key: "firstnameControl",
          ref: firstnameControl,
          modelValue: firstnameModel.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((firstnameModel).value = $event)),
          dense: "",
          outlined: "",
          autofocus: "",
          "lazy-rules": "",
          label: _ctx.$t(_unref(EMessagesKeys).REQUEST_DEMO_DIALOG_FIRSTNAME_TITLE),
          rules: [
            _unref(requiredValidator)(
              _unref(t)(_unref(EMessagesKeys).VALIDATORS_REQUIRED_COMMON_MESSAGE)
            ),
          ]
        }, null, 8, ["modelValue", "label", "rules"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_d_input, {
          ref_key: "lastnameControl",
          ref: lastnameControl,
          modelValue: lastnameModel.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lastnameModel).value = $event)),
          dense: "",
          outlined: "",
          "lazy-rules": "",
          label: _ctx.$t(_unref(EMessagesKeys).REQUEST_DEMO_DIALOG_LASTNAME_TITLE),
          rules: [
            _unref(requiredValidator)(
              _unref(t)(_unref(EMessagesKeys).VALIDATORS_REQUIRED_COMMON_MESSAGE)
            ),
          ]
        }, null, 8, ["modelValue", "label", "rules"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_d_input, {
        ref_key: "companyControl",
        ref: companyControl,
        modelValue: companyModel.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((companyModel).value = $event)),
        dense: "",
        outlined: "",
        "lazy-rules": "",
        label: _ctx.$t(_unref(EMessagesKeys).REQUEST_DEMO_DIALOG_COMPANY_NAME_TITLE),
        rules: [
          _unref(requiredValidator)(
            _unref(t)(_unref(EMessagesKeys).VALIDATORS_REQUIRED_COMMON_MESSAGE)
          ),
        ]
      }, null, 8, ["modelValue", "label", "rules"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_d_input, {
          ref_key: "emailControl",
          ref: emailControl,
          modelValue: emailModel.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((emailModel).value = $event)),
          dense: "",
          outlined: "",
          "lazy-rules": "",
          label: _ctx.$t(_unref(EMessagesKeys).REQUEST_DEMO_DIALOG_EMAIL_TITLE),
          rules: [
            _unref(requiredValidator)(
              _unref(t)(_unref(EMessagesKeys).VALIDATORS_REQUIRED_COMMON_MESSAGE)
            ),
            _unref(emailValidator)(_unref(t)(_unref(EMessagesKeys).VALIDATORS_EMAIL_COMMON_MESSAGE)),
          ]
        }, null, 8, ["modelValue", "label", "rules"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_d_input, {
          ref_key: "phoneControl",
          ref: phoneControl,
          modelValue: phoneModel.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((phoneModel).value = $event)),
          dense: "",
          outlined: "",
          label: _ctx.$t(_unref(EMessagesKeys).REQUEST_DEMO_DIALOG_PHONE_TITLE),
          "lazy-rules": "",
          rules: [
            _unref(requiredValidator)(
              _unref(t)(_unref(EMessagesKeys).VALIDATORS_REQUIRED_COMMON_MESSAGE)
            ),
          ]
        }, null, 8, ["modelValue", "label", "rules"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t(_unref(EMessagesKeys).REQUEST_DEMO_DIALOG_INDUSTRY_TITLE)), 1),
      _createVNode(_component_d_select, {
        modelValue: industryModel.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((industryModel).value = $event)),
        options: industryOptions,
        title: _ctx.$t(_unref(EMessagesKeys).REQUEST_DEMO_DIALOG_INDUSTRY_PLACEHOLDER)
      }, null, 8, ["modelValue", "title"])
    ])
  ]))
}
}

})